import { render } from "./ListPage.vue?vue&type=template&id=02456a90&ts=true"
import script from "./ListPage?vue&type=script&lang=ts"
export * from "./ListPage?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__